export default __webpack_public_path__ + "static/media/ollie.bc8fb90a.png";